import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Select, { components } from 'react-select';
import Arrow from 'images/arrowdown.svg';

import WP from 'WP';

import Media from 'css/Media';


const options = [
    {label: "1", value: 1},
    {label: "2", value: 2},
    {label: "3", value: 3},
    {label: "4", value: 4},
    {label: "5", value: 5},
    {label: "6", value: 6},
    {label: "7", value: 7},
    {label: "8", value: 8},
    {label: "9", value: 9},
    {label: "10", value: 10},
    {label: WP.trans.moreThanTen, value: 11},
    ]

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <StyledArrow isFocused={props.isFocused && !props.hasValue }/>
        </components.DropdownIndicator>
        )
    );
}

const StyledArrow = styled.div`
    background-image: url(${Arrow});
    background-repeat: no-repeat;
    background-size: contain;
    width: 10.22px;
    height: 5.45px;
    transition: transform .2s ease;

    ${props => props.isFocused && css`
        transform: rotate(180deg);
    `}
`

class DropdownList extends Component {
    
    state = {
        isFocused: false
    }

    render () {
        const {isFocused } = this.state
        const {value, onChange, defaultValue} = this.props;
        return (
            <Wrapper>
                <p>{WP.trans.numPersons}</p>
                <StyledSelect
                    name="guests"
                    options={options}
                    value={options.find(a => a.value === value)}
                    defaultValue={defaultValue}
                    onChange={({value}) => onChange(value)}
                    className="select-container"
                    placeholder=""
                    classNamePrefix={'select'}
                    onFocus={() => this.setState({isFocused: true})}
                    onBlur={() => this.setState({isFocused: false})}
                    components={{ DropdownIndicator }}
                    isFocused={isFocused}
                />
            </Wrapper>
        )
    }
}

export default DropdownList;


const Wrapper = styled.div`
    color: ${props => props.theme.colors.inputText};

    p {
        ${props => props.theme.fonts.h6}
        ${Media.greaterThan('s')`
            padding: 0 0 ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM} ;
        `}
    }
`

const StyledSelect = styled(Select)`

    .select {
        &__control {
            position: relative;
            height: 50px;
            border-radius: 0;
            width: 100%;
            height: 60px;
            border: 1px solid ${props => props.theme.colors.input};
            box-shadow: none;
            -webkit-appearance: none;
            border-radius: 0;
            ${props => props.theme.fonts.p};
            padding: 0 25px;
            background-color: ${props => props.theme.colors.negative};
            transition: border .2s ease;
            cursor: pointer;

            &:hover,
            &:focus-within {
                border-color: ${props => props.theme.colors.text};
            }
        }

        &__value-container {
            padding: 0;
        }

        &__indicator {
            &-separator {
                display: none;
            }
            svg {
                fill: ${props => props.theme.colors.input};
            }
        }

        &__menu {
            box-shadow: none;
            border: 1px solid rgba(51,51,51,.2);
            border-radius: 0;

            &-list {
                padding: 0;
            }
        }

        &__option {
            &--is-focused {
                background-color: ${props => props.theme.colors.bg};

                &:active {
                    background-color: ${props => props.theme.colors.bg};
                    opacity: .7;
                }
            }
            &--is-selected {
                background-color: ${props => props.theme.colors.bg};
                opacity: .7;
                color: ${props => props.theme.colors.text};
            }
        }
    }
`